import React from 'react';
import styled from 'styled-components';
import tw from 'tailwind.macro';
import LocalInfo from './LocalInfo';

export default ({ local, onClick }) => (
  <Local onClick={onClick} open={local.abierto}>
    <LocalInfo
      local={local}
    />
  </Local>
);

const Local = styled.div`
  ${tw`
    p-4 shadow-md bg-white mb-2 mx-2 rounded-lg text-xs cursor-pointer
  `};
  ${(props) => !props.open && tw`hidden`}
`;
